// src/generated/token.ts
var COLOR_SYSTEM_BLACK_1 = "var(--color-system-black-1)";
var COLOR_SYSTEM_BLACK_2 = "var(--color-system-black-2)";
var COLOR_SYSTEM_BLACK_3 = "var(--color-system-black-3)";
var COLOR_SYSTEM_GRAY_1 = "var(--color-system-gray-1)";
var COLOR_SYSTEM_GRAY_2 = "var(--color-system-gray-2)";
var COLOR_SYSTEM_GRAY_3 = "var(--color-system-gray-3)";
var COLOR_SYSTEM_GRAY_4 = "var(--color-system-gray-4)";
var COLOR_SYSTEM_GRAY_5 = "var(--color-system-gray-5)";
var COLOR_SYSTEM_GRAY_6 = "var(--color-system-gray-6)";
var COLOR_SYSTEM_GRAY_7 = "var(--color-system-gray-7)";
var COLOR_SYSTEM_GRAY_8 = "var(--color-system-gray-8)";
var COLOR_SYSTEM_GRAY_9 = "var(--color-system-gray-9)";
var COLOR_SYSTEM_WHITE_1 = "var(--color-system-white-1)";
var COLOR_SYSTEM_WHITE_2 = "var(--color-system-white-2)";
var COLOR_SYSTEM_WHITE_3 = "var(--color-system-white-3)";
var COLOR_SYSTEM_BRAND_1 = "var(--color-system-brand-1)";
var COLOR_SYSTEM_BRAND_2 = "var(--color-system-brand-2)";
var COLOR_SYSTEM_BRAND_3 = "var(--color-system-brand-3)";
var COLOR_SYSTEM_BRAND_4 = "var(--color-system-brand-4)";
var COLOR_SYSTEM_BRAND_5 = "var(--color-system-brand-5)";
var COLOR_SYSTEM_DANGER_1 = "var(--color-system-danger-1)";
var COLOR_SYSTEM_DANGER_2 = "var(--color-system-danger-2)";
var COLOR_SYSTEM_DANGER_3 = "var(--color-system-danger-3)";
var COLOR_SYSTEM_DANGER_4 = "var(--color-system-danger-4)";
var COLOR_SYSTEM_DANGER_5 = "var(--color-system-danger-5)";
var COLOR_SYSTEM_POINT_A_1 = "var(--color-system-point-a-1)";
var COLOR_SYSTEM_POINT_A_2 = "var(--color-system-point-a-2)";
var COLOR_SYSTEM_POINT_A_3 = "var(--color-system-point-a-3)";
var COLOR_SYSTEM_POINT_A_4 = "var(--color-system-point-a-4)";
var COLOR_SYSTEM_POINT_A_5 = "var(--color-system-point-a-5)";
var COLOR_SYSTEM_POINT_B_1 = "var(--color-system-point-b-1)";
var COLOR_SYSTEM_POINT_B_2 = "var(--color-system-point-b-2)";
var COLOR_SYSTEM_POINT_B_3 = "var(--color-system-point-b-3)";
var COLOR_SYSTEM_POINT_B_4 = "var(--color-system-point-b-4)";
var COLOR_SYSTEM_POINT_B_5 = "var(--color-system-point-b-5)";
var COLOR_BLUE_NIGHT_BLACK_1 = "var(--color-blue-night-black-1)";
var COLOR_BLUE_NIGHT_BLACK_2 = "var(--color-blue-night-black-2)";
var COLOR_BLUE_NIGHT_BLACK_3 = "var(--color-blue-night-black-3)";
var COLOR_BLUE_NIGHT_GRAY_1 = "var(--color-blue-night-gray-1)";
var COLOR_BLUE_NIGHT_GRAY_2 = "var(--color-blue-night-gray-2)";
var COLOR_BLUE_NIGHT_GRAY_3 = "var(--color-blue-night-gray-3)";
var COLOR_BLUE_NIGHT_GRAY_4 = "var(--color-blue-night-gray-4)";
var COLOR_BLUE_NIGHT_GRAY_5 = "var(--color-blue-night-gray-5)";
var COLOR_BLUE_NIGHT_GRAY_6 = "var(--color-blue-night-gray-6)";
var COLOR_BLUE_NIGHT_GRAY_7 = "var(--color-blue-night-gray-7)";
var COLOR_BLUE_NIGHT_GRAY_8 = "var(--color-blue-night-gray-8)";
var COLOR_BLUE_NIGHT_GRAY_9 = "var(--color-blue-night-gray-9)";
var COLOR_BLUE_NIGHT_WHITE_1 = "var(--color-blue-night-white-1)";
var COLOR_BLUE_NIGHT_WHITE_2 = "var(--color-blue-night-white-2)";
var COLOR_BLUE_NIGHT_WHITE_3 = "var(--color-blue-night-white-3)";
var FONT_SIZE_H0 = "var(--font-size-h0)";
var FONT_SIZE_H1 = "var(--font-size-h1)";
var FONT_SIZE_H2 = "var(--font-size-h2)";
var FONT_SIZE_H3 = "var(--font-size-h3)";
var FONT_SIZE_H4 = "var(--font-size-h4)";
var FONT_SIZE_BODY1 = "var(--font-size-body1)";
var FONT_SIZE_BODY2 = "var(--font-size-body2)";
var FONT_SIZE_BODY3 = "var(--font-size-body3)";
var FONT_SIZE_CAPTION1 = "var(--font-size-caption1)";
var FONT_SIZE_CAPTION2 = "var(--font-size-caption2)";
var FONT_SIZE_CAPTION3 = "var(--font-size-caption3)";
var FONT_WEIGHT_BLACK = "var(--font-weight-black)";
var FONT_WEIGHT_BOLD = "var(--font-weight-bold)";
var FONT_WEIGHT_SEMIBOLD = "var(--font-weight-semibold)";
var FONT_WEIGHT_REGULAR = "var(--font-weight-regular)";
var FONT_WEIGHT_LIGHT = "var(--font-weight-light)";

// src/DSL/token.ts
var COLOR_DEFAULT = "var(--color-default)";
var COLOR_BG_CARD_1 = "var(--color-bg-card-1)";
var COLOR_BG_CARD_2 = "var(--color-bg-card-2)";
var COLOR_BG_CARD_3 = "var(--color-bg-card-3)";
var COLOR_BG_CARD_4 = "var(--color-bg-card-4)";
var COLOR_TEXT_1 = "var(--color-text-1)";
var COLOR_TEXT_2 = "var(--color-text-2)";
var COLOR_TEXT_3 = "var(--color-text-3)";
var COLOR_TEXT_4 = "var(--color-text-4)";
var COLOR_TEXT_5 = "var(--color-text-5)";
var COLOR_GRAPH_1 = "var(--color-graph-1)";
var COLOR_GRAPH_2 = "var(--color-graph-2)";
var COLOR_GRAPH_3 = "var(--color-graph-3)";
var COLOR_TEXTFIELD_WHITE_DEFAULT = "var(--color-textfield-white-default)";
var COLOR_TEXTFIELD_WHITE_HOVER = "var(--color-textfield-white-hover)";
var COLOR_TEXTFIELD_WHITE_DISABLED = "var(--color-textfield-white-disabled)";
var COLOR_TEXTFIELD_GRAY_DEFAULT = "var(--color-textfield-gray-default)";
var COLOR_TEXTFIELD_GRAY_HOVER = "var(--color-textfield-gray-hover)";
var COLOR_TEXTFIELD_GRAY_DISABLED = "var(--color-textfield-gray-disabled)";
var COLOR_ALPHA_10 = "var(--color-alpha-10)";
var COLOR_ALPHA_20 = "var(--color-alpha-20)";
var COLOR_ALERT_BG = "var(--color-alert-bg)";
var COLOR_ALTER_STROKE = "var(--color-alert-stroke)";
var COLOR_DIM = "var(--color-dim)";
var COLOR_TAB_DEFAULT = "var(--color-tab-default)";
var COLOR_TAB_HOVER = "var(--color-tab-hover)";
var COLOR_TAB_SELECT = "var(--color-tab-select)";
var COLOR_TAB_SELECT_HOVER = "var(--color-tab-select-hover)";
var COLOR_TAG_DEFAULT = "var(--color-tag-default)";
var COLOR_TAG_HOVER = "var(--color-tag-hover)";
var COLOR_DASH_ICON_1 = "var(--color-dash-icon-1)";
var COLOR_DASH_ICON_2 = "var(--color-dash-icon-2)";
var COLOR_LINEAR_GRADIENT = "var(--color-linear-gradient)";
var COLOR_CONTENT_BG = "var(--color-content-bg)";
var COLOR_CONTENT_MODAL_BG = "var(--color-content-modal-bg)";
var COLOR_BRAND_1_DEFAULT = "var(--color-brand-1-default)";
var COLOR_BRAND_1_DARKER = "var(--color-brand-1-darker)";
var COLOR_BRAND_2_DEFAULT = "var(--color-brand-2-default)";
var COLOR_BRAND_2_DARKER = "var(--color-brand-2-darker)";
var COLOR_BRAND_3_DEFAULT = "var(--color-brand-3-default)";
var COLOR_BRAND_3_DARKER = "var(--color-brand-3-darker)";
var COLOR_BRAND_4_DEFAULT = "var(--color-brand-4-default)";
var COLOR_BRAND_4_DARKER = "var(--color-brand-4-darker)";
var COLOR_WHITE = "var(--color-white)";
var COLOR_OFF_BLACK = "var(--color-off-black)";
var COLOR_GRAY_1 = "var(--color-gray-1)";
var COLOR_GRAY_2 = "var(--color-gray-2)";
var COLOR_GRAY_3 = "var(--color-gray-3)";
var COLOR_GRAY_4 = "var(--color-gray-4)";
var TRANSITION_DEFAULT = "var(--transition-default)";
export {
  COLOR_ALERT_BG,
  COLOR_ALPHA_10,
  COLOR_ALPHA_20,
  COLOR_ALTER_STROKE,
  COLOR_BG_CARD_1,
  COLOR_BG_CARD_2,
  COLOR_BG_CARD_3,
  COLOR_BG_CARD_4,
  COLOR_BLUE_NIGHT_BLACK_1,
  COLOR_BLUE_NIGHT_BLACK_2,
  COLOR_BLUE_NIGHT_BLACK_3,
  COLOR_BLUE_NIGHT_GRAY_1,
  COLOR_BLUE_NIGHT_GRAY_2,
  COLOR_BLUE_NIGHT_GRAY_3,
  COLOR_BLUE_NIGHT_GRAY_4,
  COLOR_BLUE_NIGHT_GRAY_5,
  COLOR_BLUE_NIGHT_GRAY_6,
  COLOR_BLUE_NIGHT_GRAY_7,
  COLOR_BLUE_NIGHT_GRAY_8,
  COLOR_BLUE_NIGHT_GRAY_9,
  COLOR_BLUE_NIGHT_WHITE_1,
  COLOR_BLUE_NIGHT_WHITE_2,
  COLOR_BLUE_NIGHT_WHITE_3,
  COLOR_BRAND_1_DARKER,
  COLOR_BRAND_1_DEFAULT,
  COLOR_BRAND_2_DARKER,
  COLOR_BRAND_2_DEFAULT,
  COLOR_BRAND_3_DARKER,
  COLOR_BRAND_3_DEFAULT,
  COLOR_BRAND_4_DARKER,
  COLOR_BRAND_4_DEFAULT,
  COLOR_CONTENT_BG,
  COLOR_CONTENT_MODAL_BG,
  COLOR_DASH_ICON_1,
  COLOR_DASH_ICON_2,
  COLOR_DEFAULT,
  COLOR_DIM,
  COLOR_GRAPH_1,
  COLOR_GRAPH_2,
  COLOR_GRAPH_3,
  COLOR_GRAY_1,
  COLOR_GRAY_2,
  COLOR_GRAY_3,
  COLOR_GRAY_4,
  COLOR_LINEAR_GRADIENT,
  COLOR_OFF_BLACK,
  COLOR_SYSTEM_BLACK_1,
  COLOR_SYSTEM_BLACK_2,
  COLOR_SYSTEM_BLACK_3,
  COLOR_SYSTEM_BRAND_1,
  COLOR_SYSTEM_BRAND_2,
  COLOR_SYSTEM_BRAND_3,
  COLOR_SYSTEM_BRAND_4,
  COLOR_SYSTEM_BRAND_5,
  COLOR_SYSTEM_DANGER_1,
  COLOR_SYSTEM_DANGER_2,
  COLOR_SYSTEM_DANGER_3,
  COLOR_SYSTEM_DANGER_4,
  COLOR_SYSTEM_DANGER_5,
  COLOR_SYSTEM_GRAY_1,
  COLOR_SYSTEM_GRAY_2,
  COLOR_SYSTEM_GRAY_3,
  COLOR_SYSTEM_GRAY_4,
  COLOR_SYSTEM_GRAY_5,
  COLOR_SYSTEM_GRAY_6,
  COLOR_SYSTEM_GRAY_7,
  COLOR_SYSTEM_GRAY_8,
  COLOR_SYSTEM_GRAY_9,
  COLOR_SYSTEM_POINT_A_1,
  COLOR_SYSTEM_POINT_A_2,
  COLOR_SYSTEM_POINT_A_3,
  COLOR_SYSTEM_POINT_A_4,
  COLOR_SYSTEM_POINT_A_5,
  COLOR_SYSTEM_POINT_B_1,
  COLOR_SYSTEM_POINT_B_2,
  COLOR_SYSTEM_POINT_B_3,
  COLOR_SYSTEM_POINT_B_4,
  COLOR_SYSTEM_POINT_B_5,
  COLOR_SYSTEM_WHITE_1,
  COLOR_SYSTEM_WHITE_2,
  COLOR_SYSTEM_WHITE_3,
  COLOR_TAB_DEFAULT,
  COLOR_TAB_HOVER,
  COLOR_TAB_SELECT,
  COLOR_TAB_SELECT_HOVER,
  COLOR_TAG_DEFAULT,
  COLOR_TAG_HOVER,
  COLOR_TEXTFIELD_GRAY_DEFAULT,
  COLOR_TEXTFIELD_GRAY_DISABLED,
  COLOR_TEXTFIELD_GRAY_HOVER,
  COLOR_TEXTFIELD_WHITE_DEFAULT,
  COLOR_TEXTFIELD_WHITE_DISABLED,
  COLOR_TEXTFIELD_WHITE_HOVER,
  COLOR_TEXT_1,
  COLOR_TEXT_2,
  COLOR_TEXT_3,
  COLOR_TEXT_4,
  COLOR_TEXT_5,
  COLOR_WHITE,
  FONT_SIZE_BODY1,
  FONT_SIZE_BODY2,
  FONT_SIZE_BODY3,
  FONT_SIZE_CAPTION1,
  FONT_SIZE_CAPTION2,
  FONT_SIZE_CAPTION3,
  FONT_SIZE_H0,
  FONT_SIZE_H1,
  FONT_SIZE_H2,
  FONT_SIZE_H3,
  FONT_SIZE_H4,
  FONT_WEIGHT_BLACK,
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_LIGHT,
  FONT_WEIGHT_REGULAR,
  FONT_WEIGHT_SEMIBOLD,
  TRANSITION_DEFAULT
};
//# sourceMappingURL=index.js.map